import { useEffect } from 'react'
import { saveDraft } from '../draftStore'
import { IContentFormData } from '../types'

/**
 * Persists the form draft to localStorage without causing re-renders.
 *
 * Strategy:
 *  - Every INTERVAL_MS ms: read current values via getValues() (no re-render)
 *    and write to localStorage if the form has meaningful data.
 *  - On `beforeunload` (tab close / browser crash): save synchronously.
 *
 * The reader supplies the current content and any page metadata.
 * Replacing it renews the listener; unmount always clears persistence.
 */

const INTERVAL_MS = 3_000

export const useDraftPersistence = (getValues: () => IContentFormData): void => {
  useEffect(() => {
    const save = () => {
      saveDraft(getValues())
    }

    const interval = setInterval(save, INTERVAL_MS)

    window.addEventListener('beforeunload', save)

    return () => {
      clearInterval(interval)
      window.removeEventListener('beforeunload', save)
    }
  }, [getValues])
}
